import { TALENT_ID } from '../ids/talent-id'
import { TalentMap } from 'web/data/models'
import { SPEC_ID } from '../ids/spec-ids'

export const SHAMAN_TALENTS: TalentMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Resto
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [TALENT_ID.SHAMAN.RESTO.APT]: {
        id: TALENT_ID.SHAMAN.RESTO.APT,
        specId: SPEC_ID.SHAMAN.RESTO,

        name: "Ancestral Protection Totem",
        shortName: "APT",

        game_id: 207399,
        icon_name: "spell_nature_reincarnation"
    },

    [TALENT_ID.SHAMAN.RESTO.WRT]: {
        id: TALENT_ID.SHAMAN.RESTO.WRT,
        specId: SPEC_ID.SHAMAN.RESTO,

        name: "Wind Rush Totem",
        shortName: "WRT",

        game_id: 192077,
        icon_name: "ability_shaman_windwalktotem"
    },

}
